import { useEffect, useState } from "react";
import Button from "./Buttons/Button";

const ToggleSwitch = ({ toggleObjects, direction = "flex flex-row", classNames= "gap-3 w-full rounded-lg", buttonClasses = "w-full border-0", backgroundClasses="rounded-lg bg-[#F3F4F6] p-1" }) => {
    const [activeIndex, setActiveIndex] = useState(0);

    const handleToggleView = (e, index, specialAction) => {
        e.preventDefault();
        setActiveIndex(index);
        if (specialAction) {
            specialAction();
        }
    };
    return (
        <div className={`${direction} ${classNames} ${backgroundClasses}`}>
            {toggleObjects.map((obj, index) => (
                <Button
                    key={index}
                    classNames={buttonClasses}
                    buttonColor={index === activeIndex ? (obj.selectedStyle ? obj.selectedStyle : "bg-white" )  : (obj.unselectedStyle ? obj.unselectedStyle : "bg-[#F3F4F6]")}
                    text={obj.text}
                    tIconName={obj.icon}
                    tIconColor={index === activeIndex ? (obj.iconColor ? obj.iconColor : "black") : "black"}
                    onClickAction={(e) => handleToggleView(e, index, obj.onClickAction)}
                />
            ))}
        </div>
    );
};

export default ToggleSwitch;
